__turbopack_context__.v({
  "btn": "ScrollTop-module-scss-module__OqEyrW__btn",
  "visible": "ScrollTop-module-scss-module__OqEyrW__visible",
});
